/**
 * @file: index.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import TouchableOpacity, {
  type EulerTouchableOpacityProps,
} from './TouchableOpacity';
import View, { type EulerViewProps } from './View';

const Euler = { View, TouchableOpacity };

export type { EulerTouchableOpacityProps, EulerViewProps };

export default Euler;
